import { userState } from './user-state';
import { iframeCommunication } from './iframe-communication';
export function initializeHeaderAuth() {
    const loginLogoutBtn = document.getElementById('login-logout-btn');
    const loginIcon = document.getElementById('login-icon');
    const logoutIcon = document.getElementById('logout-icon');
    const exploreLink = document.getElementById('explore-link');
    const mainContent = document.getElementById('main-content');
    const iframeContainer = document.getElementById('iframe-container');
    const footer = document.querySelector('footer');
    if (!loginLogoutBtn || !loginIcon || !logoutIcon || !exploreLink || !mainContent || !iframeContainer) {
        console.error('[header-auth] Required elements not found');
        return;
    }
    console.log('[header-auth] Initializing header auth functionality');
    // Update button state based on user login status
    function updateButtonState(isLoggedIn) {
        if (isLoggedIn) {
            // Show logout button
            loginLogoutBtn.classList.remove('hidden');
            loginIcon.classList.add('hidden');
            logoutIcon.classList.remove('hidden');
            loginLogoutBtn.setAttribute('aria-label', 'Logout');
            loginLogoutBtn.setAttribute('title', 'Logout from playground');
        }
        else {
            // Show login button
            loginLogoutBtn.classList.remove('hidden');
            loginIcon.classList.remove('hidden');
            logoutIcon.classList.add('hidden');
            loginLogoutBtn.setAttribute('aria-label', 'Login');
            loginLogoutBtn.setAttribute('title', 'Login to playground');
        }
    }
    // Handle login/logout button click
    loginLogoutBtn.addEventListener('click', (e) => {
        e.preventDefault();
        if (userState.isLoggedIn()) {
            // User is logged in, send logout message
            console.log('[header-auth] Sending logout message to iframe');
            iframeCommunication.sendLogout();
        }
        else {
            // User is not logged in, show iframe (same as explore link)
            console.log('[header-auth] Showing iframe for login');
            mainContent.classList.add('hidden');
            iframeContainer.classList.remove('hidden');
            if (footer)
                footer.classList.add('hidden');
        }
    });
    // Listen for user state changes
    userState.onUserChange((user) => {
        updateButtonState(user !== null);
    });
    // Initialize button state (hidden by default until we know user status)
    loginLogoutBtn.classList.add('hidden');
    // Show button immediately if we already have user state
    if (userState.isLoggedIn()) {
        updateButtonState(true);
    }
    else {
        updateButtonState(false);
    }
    console.log('[header-auth] Header auth functionality initialized');
}
